import { Consumption } from '@/interfaces';
import type { ColumnDefinition } from '@trading-ui/datagrid-v3';

import i18n from '@/i18n/config';

import { MathUtils } from '@/utils/math.utils';

const BG_COLOR = 'rgba(4, 120, 178, 0.2)';
const TEXT_COLOR = '#0478B2';
const TEXT_COLOR_DIFFERENCE = '#02486B';

export const getColumns = (): ColumnDefinition[] => [
  {
    title: i18n.t('consumer.tablePanel.columns.date'),
    field: 'date',
    headerSort: false,
    minWidth: 80,
    formatter: (cell) => {
      const value = cell.getValue();
      if (!value) return '';
      const date = value instanceof Date ? value : new Date(value);
      const cellElement = cell.getElement();
      if (cellElement) {
        cellElement.style.backgroundColor = BG_COLOR;
        cellElement.style.color = TEXT_COLOR;
      }
      return date.toLocaleDateString();
    },
  },
  {
    title: i18n.t('consumer.tablePanel.columns.nomination'),
    field: 'nomination',
    headerSort: false,
    editor: 'input',
    editorParams: {
      search: false,
      selectContents: true,
      elementAttributes: {
        type: 'number',
      },
    },
    minWidth: 80,
    formatter: (cell) => {
      // Check if this is during editing by looking at the element
      const element = cell.getElement();
      const isEditing = element && element.classList.contains('tabulator-editing');

      if (isEditing) {
        return cell.getValue();
      }

      return MathUtils.formatNumber(cell.getValue());
    },
    tooltip(_event, cell) {
      const row = cell.getRow();
      const rowData = row.getData() as Consumption;
      const { updatedBy } = rowData;

      if (!updatedBy) return i18n.t('consumer.tablePanel.tooltip.pleaseInsertValueInKwh');

      return `${i18n.t('consumer.tablePanel.tooltip.updatedBy')}: ${updatedBy}`;
    },
  },
  {
    title: i18n.t('consumer.tablePanel.columns.enagas'),
    field: 'enagas',
    headerSort: false,
    minWidth: 80,
    formatter: (cell) => {
      const value = cell.getValue();
      const cellElement = cell.getElement();
      if (cellElement) {
        cellElement.style.backgroundColor = BG_COLOR;
        cellElement.style.color = TEXT_COLOR;
      }

      const formatted = MathUtils.formatNumber(value);
      return formatted !== '' ? formatted : value;
    },
    tooltip(_event, cell) {
      const row = cell.getRow();
      const rowData = row.getData() as Consumption;
      const { type } = rowData;

      if (!type) return '';

      return type;
    },
  },
  {
    title: i18n.t('consumer.tablePanel.columns.difference'),
    field: 'difference',
    headerSort: false,
    minWidth: 80,
    formatter: (cell) => {
      const value = cell.getValue();
      const cellElement = cell.getElement();
      if (cellElement) {
        cellElement.style.backgroundColor = BG_COLOR;
        cellElement.style.color = TEXT_COLOR_DIFFERENCE;
      }

      const formatted = MathUtils.formatNumber(value);
      return formatted !== '' ? formatted : value;
    },
  },

  {
    title: i18n.t('consumer.tablePanel.columns.cups'),
    field: 'plant.alias',
    headerSort: false,
    minWidth: 100,
    formatter: (cell) => {
      const cellElement = cell.getElement();
      if (cellElement) {
        cellElement.style.backgroundColor = BG_COLOR;
        cellElement.style.color = TEXT_COLOR;
      }
      return cell.getValue();
    },
  },
];
